import MinigirdListPresenter from "./MingridList/MinigirdListPresenter";
import MinigridAddButtonPresenter from "./MinigridAddButton/MinigridAddButton";
import SearchMinigridPresenter from "./SearchMinigrid/SearchMinigridPresenter";
import MinigridListMap from "./MinigridListMap/MinigridListMap";

export const MinigridList = {
    List: MinigirdListPresenter,
    CreatNewMinigrid: MinigridAddButtonPresenter,
    SearchInput: SearchMinigridPresenter,
    Map: MinigridListMap,
}